import { render, staticRenderFns } from "./FormCallbackPage.vue?vue&type=template&id=4c7f0b92&scoped=true&"
import script from "./FormCallbackPage.vue?vue&type=script&lang=js&"
export * from "./FormCallbackPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7f0b92",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c7f0b92')) {
      api.createRecord('4c7f0b92', component.options)
    } else {
      api.reload('4c7f0b92', component.options)
    }
    module.hot.accept("./FormCallbackPage.vue?vue&type=template&id=4c7f0b92&scoped=true&", function () {
      api.rerender('4c7f0b92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/FormCallbackPage.vue"
export default component.exports